<template>
    <div class="card one-third" :id="'card_' + entry.id">
        <div>
            <div class="visible-card">
                <div
                    v-if="entry.main_image"
                    class="card-image"
                >
                    <a
                        :href="entry.main_image.full"
                        target="_blank"
                    >
                        <img
                            :src="entry.main_image.large"
                            :data-zoom-src="entry.main_image.large"
                            data-zoomable="true"
                        />
                    </a>
                </div>
                <div class="card-block-container">

                    <div class="card-block">
                        <div>
                            <div
                                v-if="contest.type === 'cover_search_contest'"
                            >
                                <h4 class="text-lg mb-1">
                                    {{ entry.item_name }}
                                </h4>
                                <h4
                                    class="mb-1"
                                    v-if="entry.user"
                                >
                                    Photo by {{ entry.user.name }}
                                </h4>
                            </div>
                            <div
                                v-else
                            >
                                <h4 class="card-title">
                                    {{ entry.item_name }}
                                </h4>
                                <h4
                                    class="card-title"
                                    v-if="entry.user"
                                >
                                    Photo by {{ entry.user.name }}
                                </h4>
                                <h4 class="card-title">
                                    Category: {{ entry.item_att1 }}
                                </h4>
                            </div>
                            <p class="card-text">
                                {{ showMore ? entry.item_description : item_desc }}
                                <span
                                    v-if="more"
                                    v-on:click="showMore = !showMore">
                                    Read {{ showMore ? 'less' : 'more' }}
                                </span>
                                <span v-else></span>
                            </p>
                        </div>
                        <div class="card-actions">
                            <div v-if="canVote">
                                <vote-heart
                                    :entry="entry"
                                />
                            </div>
                            <div class="share-buttons-container flex">
                                <router-link
                                    class="link-icon-container share-icon"
                                    :to="'/contests/' + contest.slug + '/entries/' + entry.id"
                                >
                                    <link-icon/>
                                </router-link>
                                <a class="share-icon"
                                   :href="'https://www.facebook.com/sharer/sharer.php?u=' + MAIN_URL + '/contests/' + contest.slug + '/entries/' + entry.id + '&quote=' + share_text"
                                   target="_blank">
                                    <div class="facebook-icon">
                                        <facebook-icon/>
                                    </div>
                                </a>
                                <a class="share-icon"
                                   :href="'http://twitter.com/share?url=' + MAIN_URL + '/contests/' + contest.slug + '/entries/' + entry.id + '&text=' + share_text"
                                   target="_blank">
                                    <div>
                                        <twitter-icon/>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {ENV_URL, S3_URL, MAIN_URL} from '../../environment.js';
import VoteHeart from '@/js/components/contests/VoteHeart.vue';
import FacebookIcon from '@/js/components/ui/FacebookIcon.vue';
import TwitterIcon from '@/js/components/ui/TwitterIcon.vue';
import LinkIcon from '@/js/components/ui/LinkIcon.vue';
var smoothScroll = require('smoothscroll');

export default {
    components: {
        VoteHeart,
        FacebookIcon,
        TwitterIcon,
        LinkIcon,
    },
    props: ['entry', 'imageSize'],

    data() {
        return {
            votes: 0,
            showMore: false,
            currentUser: null,
            MAIN_URL: MAIN_URL,
            S3_URL: S3_URL,
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        contest() {
            return this.$store.state.contest;
        },
        mainImage() {
            if (this.entry.media && this.entry.media.length) {
                return this.entry.media[0];
            }
            return null;
        },
        get_contest_id() {
            return this.contest.id;
        },
        share_text() {
            var share_text = this.contest.status == 'vote' ? "Vote for " + this.entry.item_name + " in the New Jersey Monthly " + this.contest.title + "!"
                : this.entry.item_name + " has entered the New Jersey Monthly " + this.contest.title + "!";
            return share_text;
        },
        item_desc() {
            var full_desc = this.entry.item_description;
            var item_desc = '';
            let more = false;
            if (full_desc !== null && full_desc.length > 300) {
                more = true;
                item_desc = full_desc.slice(0, 290) + '...';
            } else {
                item_desc = full_desc !== null ? full_desc : '';
            }
            return item_desc;
        },

        more() {
            var full_desc = this.entry.item_description;
            return full_desc !== null && full_desc.length > 300;
        },
        canVote () {
            return this.contest.status === 'vote' || (this.user && this.user.admin_level > 0 && this.contest.settings && this.contest.settings.admin_voting === true);
        }
    },
    methods: {
        get_user_level() {
            return this.user !== null ? this.user.admin_level : -1;
        },
    },
}
</script>

<style lang="scss">
.card-content {
    text-transform: capitalize;
}
.card-content p.card-text {
    text-transform: none;
}
</style>

